import { render, staticRenderFns } from "./BootstrapModal.vue?vue&type=template&id=64ba9cbe&scoped=true"
import script from "./BootstrapModal.vue?vue&type=script&lang=js"
export * from "./BootstrapModal.vue?vue&type=script&lang=js"
import style0 from "./BootstrapModal.vue?vue&type=style&index=0&id=64ba9cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba9cbe",
  null
  
)

export default component.exports